var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"inline-block mr-1",domProps:{"innerHTML":_vm._s(_vm.params.data.currency_details.code)}}),_vm._v("\n     "+_vm._s(_vm.params.data.amount)+"\n   ")])
}
var staticRenderFns = []

export { render, staticRenderFns }